export const DECILE = 'Decile'
export const HUNDRED = '1-100'

export interface ReadDIQuery {
  di_hs_avg: string
  di_nh_avg: string
}
export interface ReadDIQueryData {
  readDIQuery: ReadDIQuery
}

export interface ReadStudentContext {
  st_a_hs_college_access: number
  id: string
  geo_2010: string
  geo_2020: string
  applicant_id: string
  di_code: string
  job_id: string
  term: string
  old_sat_math: string
  old_sat_cr: string
  old_sat_writing: string
  sat_math: string
  sat_ebrw: string
  act_english: string
  act_math: string
  act_science: string
  act_reading: string
  act_writing: string
  act_composite: string
  display_score: string
  score_source: string
  hs_ceeb_cd: string
  gender: string
  a_nh_college_access: string
  a_nh_crime_ptile: string
  a_nh_family_ptile: string
  a_nh_educ_ptile: string
  a_nh_housing_ptile: string
  a_nh_medfaminc_ptile: string
  a_nh_overrall_ptile: string
  a_nh_overall_decile: string
  rural: string
  bie_school: string
  ddv_apcapstone: string
  a_hs_satc_25: string
  a_hs_satc_50: string
  a_hs_satc_75: string
  ari_rank: string
  ncessch: string
  org_nm: string
  a_sr_class_size: string
  a_pct_taking_sat: number
  a_avg_coll_sat_hs: string
  a_avg_frl_pct: string
  a_hs_crime_ptile: string
  a_hs_college_access: string
  a_hs_family_ptile: string
  a_hs_educ_ptile: string
  a_hs_housing_ptile: string
  a_hs_medfaminc_ptile: string
  a_hs_overrall_ptile: string
  a_hs_overall_decile: string
  application_type: string
  admitted: string
  enrolled: string
  waitlist: string
  first_year_gpa: string
  sophomore_retention: string
  need_based_grant: string
  pell_recipient: string
  pell_eligible: string
  race: string
  entry_term: number
  first_generation: string
  adv_avgapscore: string
  a_pct_taking_ap: string
  adv_aptestavail: string
  adv_aptaken: string
  dashboard_link: string
  a_overall: string
  adv_appct: string
  create_date: string
  hsgpa: string
  number_of_ap_exams: string
  ap_average: string
  number_of_ib_exams: string
  ib_average: string
  a_nh_svi_ptile: string
  a_nh_share_no_inter: string
  st_a_nh_college_access: string
  st_a_nh_crime_ptile: string
  st_a_nh_educ_ptile: string
  st_a_nh_family_ptile: string
  st_a_nh_housing_ptile: string
  st_a_nh_medfaminc_ptile: string
  st_a_nh_overrall_ptile: string
  st_a_hs_crime_ptile: string
  st_a_hs_college_access_ptile: string
  st_a_hs_educ_ptile: string
  st_a_hs_housing_ptile: string
  st_a_hs_family_ptile: string
  st_a_hs_medfaminc_ptile: string
  st_a_hs_overrall_ptile: string
  st_a_overall: string
  city: string
  state: string
  country: string
  address1: string
  address2: string
  address3: string
  zip: string
  custom_1: string
  custom_2: string
  custom_3: string
  po_box: string
  chartDisplayUnits: string
  frl_flag: string
}

export interface ReadStudentContextData {
  readStudentContext: ReadStudentContext
}
